import { compareObjectIds, Id } from './compare';

type EntityWithId = {
  _id: Id;
};

export function findById<T extends EntityWithId>(
  items: T[] | undefined,
  id: Id,
  context?: string
): T | undefined {
  if (!items?.length || id == null) {
    return undefined;
  }

  return items.find((item) => compareObjectIds(item._id, id, context));
}